export const defaultShortDateFormat = "MMM d, yy";
export const defaultShortDateFormatFullYear = "MMM d, yyyy";
export const defaultDateFormat = "EEE, MMM d, yyyy";
export const defaultDateWithTimeFormat = `${defaultDateFormat} 'at' h:mmaaa`;
export const defaultDateWithTimeAndZoneFormat = `${defaultDateFormat} 'at' h:mmaaa zzzz`;
export const defaultShortDateWithTimeAndZoneFormat = `${defaultDateFormat} 'at' h:mmaaa z`;

export const defaultTimeZone = "America/Los_Angeles";
